import Velocity from 'velocity-animate';

import Component from '../../components/component/component';
import Header from '../../components/header/header';
import Helpers from '../../components/helpers/helpers';

import './outro.scss';

export interface IOutroSettings {
    containerSelector: string;
    imageContainerSelector: string;
    dummyImageSelector: string;
    imageSelector: string;
    ctaSelector: string;
    fadeOutClass: string;
    fadeInClass: string;
    headerSelector: string;
}

export default class Outro extends Component {
    static initSelector: string = '.outro';

    dummyImage: JQuery;
    image: JQuery;
    cta: JQuery;
    header: JQuery;
    settings: IOutroSettings;
    timeout: number;
    videoContainer: JQuery;
    imageContainer: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.settings = {
            containerSelector: '.outro__video-container',
            imageContainerSelector: '.outro__image-container',
            dummyImageSelector: '.outro__dummy-image:not(.image--full)',
            imageSelector: '.outro__image',
            ctaSelector: '.outro__cta-container',
            fadeOutClass: 'fade-out',
            fadeInClass: 'fade-in',
            headerSelector: Header.initSelector,
        };

        this.dummyImage = this.element.find(this.settings.dummyImageSelector);
        this.image = this.element.find(this.settings.imageSelector);
        this.cta = this.element.find(this.settings.ctaSelector);
        this.header = $(document).find(this.settings.headerSelector);
        this.videoContainer = this.element.find(this.settings.containerSelector);
        this.imageContainer = this.element.find(this.settings.imageContainerSelector);

        this.init();
    }

    init(): void {
        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }

        this.timeout = window.setTimeout(() => {
            this.element.addClass('fade-in');

            if (window.matchMedia('(min-width: ' + Helpers.bp.sm + 'px)').matches && this.dummyImage.length > 0 && !this.element.hasClass('outro--full-width') && !this.element.hasClass('outro--w-form')) {
                Velocity(this.dummyImage, {
                    height: this.videoContainer.height(),
                    width: '83.33334%', // equal to 20 columns out of 24
                }, {
                    complete: this.onAnimationComplete.bind(this),
                    duration: 600,
                    easing: [.8, 0, .2, 1],
                });
            } else {
                Velocity(this.image, {
                    height: this.imageContainer.height(),
                    width: '83.33334%', // equal to 20 columns out of 24
                }, {
                    complete: this.onAnimationComplete.bind(this),
                    duration: 600,
                    easing: [.8, 0, .2, 1],
                });
            }

            this.header.addClass(Header.fadeInClass);
        }, 800);
    }

    onAnimationComplete(): void {
        this.dummyImage.addClass(this.settings.fadeOutClass);
        this.cta.addClass(this.settings.fadeInClass);
    }
}
